import { render, staticRenderFns } from "./deleteParkingArea.vue?vue&type=template&id=c4a40492"
import script from "./deleteParkingArea.vue?vue&type=script&lang=js"
export * from "./deleteParkingArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports